/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Col, Row } from 'react-bootstrap';
import {
  faClock,
  faCheckCircle,
  faCircle,
  faStopCircle,
  faXmarkCircle
} from '@fortawesome/free-regular-svg-icons';

import { faBan, faCrosshairs } from '@fortawesome/free-solid-svg-icons';
import EmployeeLeaveDetailCard from '../EmployeeLeaveDetailCard';
import LeaveBasicTimeline from 'components/custom/ui/timeline/LeaveBasicTimeline';
import useFetchData from 'hooks/custom/useFetchData';
import apiEndpoints from 'constants/apiEndpoints';

// {timelineData.map((timeline, index) => (
//   <div key={timeline.leave_id}>
//     {/* <h4 className="py-3 border-y border-300 mb-5 ms-8">
//       {timeline.date}
//     </h4> */}
//     <LeaveBasicTimeline data={timeline.leave_data} />
//   </div>
// ))}
export const timelineData = [
  {
    id: 1,
    date: 'Leave',
    items: [
      {
        id: 14,
        time: '3:00pm',
        icon: faCircle,
        iconColor: 'warning',
        fromDate: '10 September 2024',
        toDate: '12 September 2024',
        totalDays: 3,
        leaveType: 'Casual Leave',
        approval: 'Pending',
        reason: 'i have some personal work'
      },
      {
        id: 16,
        time: '6:00pm',
        icon: faCheckCircle,
        iconColor: 'success',
        fromDate: '5 March 2024',
        toDate: '15 March 2024',
        totalDays: 11,
        leaveType: 'Casual Leave',
        approval: 'Approved',
        reason: 'i have some personal work'
      },
      {
        id: 15,
        time: '4:00pm',
        icon: faCheckCircle,
        iconColor: 'success',
        fromDate: '2 January 2024',
        toDate: '6 January 2024',
        totalDays: 5,
        leaveType: 'Emergency Leave',
        approval: 'Approved',
        reason: 'i have some personal work'
      },

      {
        id: 13,
        time: '1:00pm',
        icon: faXmarkCircle,
        iconColor: 'danger',
        fromDate: '12 November 2024',
        toDate: '13 November 2024',
        totalDays: 2,
        leaveType: 'Half Day',
        approval: 'Rejected',
        reason: 'i have some personal work'
      },
      {
        id: 12,
        time: '12:00pm',
        icon: faXmarkCircle,
        iconColor: 'danger',
        fromDate: '3 October 2024',
        toDate: '6 October 2024',
        totalDays: 4,
        leaveType: 'Sick leave',
        approval: 'Rejected',
        reason: 'i have some personal work'
      },
      {
        id: 11,
        time: '9:00am',
        icon: faCheckCircle,
        iconColor: 'success',
        fromDate: '2 july 2024',
        toDate: '4 july 2024',
        totalDays: 3,
        leaveType: 'Casual Leave',
        approval: 'Approved',
        reason: 'i have some personal work'
      }
    ]
  }
];

export default function EmployeeLeaveDetails(data) {
  const [visibleCount, setVisibleCount] = useState(2);

  const showMore = () => {
    setVisibleCount(2);
  };

  const [employeeLeaveData] = useFetchData(
    apiEndpoints.leave.employeeleaveDetail(
      data.data.personal_information.employee_id
    )
  );
  console.log(
    '🚀 ~ EmployeeLeaveDetails ~ employeeLeaveData:',
    employeeLeaveData
  );

  return (
    <div className="container mt-4">
      <h2 className="mb-2">Leave</h2>
      <Row>
        <EmployeeLeaveDetailCard
          employeeLeaveData={employeeLeaveData}
          className="mb-3"
        />
      </Row>
      <Row className="gx-xl-8 gx-xxl-11 py-3 mt-4 border-y border-300">
        <Col xl={7} className="scrollbar w-100 mt-3">
          <div>
            {employeeLeaveData?.leave_data?.length ? (
              <LeaveBasicTimeline data={employeeLeaveData?.leave_data || []} />
            ) : (
              <div className="text-danger text-canter w-100">
                Not applied any leave
              </div>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
}
